export default Object.freeze({
  EDIT: 'EDITING',
  REORDER: 'REORDERING',
  PLACE_NEW: 'PLACING_NEW',
});
